import React from 'react';
import {styles} from './list_styles.web';
import {ListProps} from './list_types.web';
import {useTheme} from '../../../../utils/theming/themeProvider';
import ListItem from '../ListItem/listItem.web';

const List = (props: React.PropsWithChildren<ListProps>) => {
  // Props
  const {id, className, bgColor, list, borderTop, containerStyle} = props;

  // Styles
  const {colors, fontStyles} = useTheme();

  return (
    <div
      id={id}
      className={className}
      style={{
        ...styles().listContainer,
        backgroundColor: bgColor
          ? bgColor === 'grey'
            ? colors.neutral200
            : colors.neutral100
          : 'transparent',
        borderTop: borderTop ? `1px solid ${colors.neutral300}` : 0,
        borderTopLeftRadius: borderTop ? 0 : 8,
        borderTopRightRadius: borderTop ? 0 : 8,
        ...containerStyle,
      }}>
      {list?.map((item, index) => (
        <ListItem {...item} key={index} />
      ))}
    </div>
  );
};

export default List;
